import { render, staticRenderFns } from "./WaybillSorted.vue?vue&type=template&id=1e50227b&scoped=true&"
import script from "./WaybillSorted.vue?vue&type=script&lang=js&"
export * from "./WaybillSorted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e50227b",
  null
  
)

export default component.exports